import { getHttpApi } from '@cian/http-api/browser';
import {
  fetchGetRegionsByPoint,
  IGetRegionsByPointRequest,
  TGetRegionsByPointResponse,
} from '../../../../../../shared/repositories/geo/v1/get-regions-by-point';

export const getRegionsByPoint = async (parameters: IGetRegionsByPointRequest) => {
  const response: TGetRegionsByPointResponse = await fetchGetRegionsByPoint({
    httpApi: getHttpApi(),
    parameters,
  });

  if (response.statusCode !== 200) {
    throw new Error(response.response.message);
  }

  return response.response.regionLocations || [];
};
